import _styled from "../../../_snowpack/pkg/styled-components.js";
import React, { useEffect, useState } from '../../../_snowpack/pkg/react.js';
import config from '../../app-config.js'; // @ts-ignore

import { Button } from '../../css/index.js'; // @ts-ignore

import { Wrapper, Title } from './styles.js';

var _StyledWrapper = _styled(Wrapper).withConfig({
  displayName: "magic-link-landing-page___StyledWrapper",
  componentId: "lpr6l7-0"
})(["justify-content:center;"]);

export default function MagicLinkLandingPage() {
  const token = new URL(window.location.href).searchParams.get('token');
  /**
   * Do not set href immediately in case an email
   * client crawls the page and visits all links
   * before the user has a chance to click the link
   */

  const [href, setHref] = useState('/');
  useEffect(() => {
    const timeout = setTimeout(() => {
      setHref(`${config.API_URL}/auth/magic-link/redirect?token=${token}`);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [token]);
  return /*#__PURE__*/React.createElement(_StyledWrapper, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Title, null, "Login to Crystallize"), /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: href
  }, "Click to login to PIM")));
}